import { mergeStyleSets } from '@fluentui/react';

export const useStyles = () => {
  return mergeStyleSets({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
    },
    row: {
      display: 'flex',
      gap: 8,
      alignItems: 'flex-end',
    },
    delayField: {
      width: 100,
    },
  });
};
